export const SEARCH_LIMIT = 10;
export const IMAGE_SIZE = 160;
